import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  siteSetting: {},
};

const settingsSlice = createSlice({
  name: "siteSetting",
  initialState,
  reducers: {
    getSettings: (state, action) => {
      state.siteSetting = action.payload;
    },
  },
});

export const { getSettings } = settingsSlice?.actions;
export default settingsSlice?.reducer;
